import { useState, useEffect } from 'react';

interface CommunityStats {
  members: number;
  countries: number;
  loading: boolean;
}

/**
 * Shared hook for fetching community stats
 * Used by both About and Community components to avoid duplicate fetches
 */
export function useCommunityStats(): CommunityStats {
  const [stats, setStats] = useState<CommunityStats>({
    members: 0,
    countries: 0,
    loading: true
  });

  useEffect(() => {
    let cancelled = false;

    fetch("https://cbuxrdarzwtolyjhnhzw.supabase.co/storage/v1/object/public/globe-cache/community_map.json")
      .then(res => res.json())
      .then(data => {
        if (cancelled) return;
        
        const users = Array.isArray(data) ? data : data.data;
        
        // Calculate unique countries
        const uniqueCountries = new Set(users.map((u: any) => u.country).filter(Boolean));
        
        setStats({
          members: users.length,
          countries: uniqueCountries.size,
          loading: false
        });
      })
      .catch(err => {
        if (cancelled) return;
        setStats(prev => ({ ...prev, loading: false }));
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return stats;
}

